import { Routes } from '@angular/router';
import { DashboardLayoutComponent } from '../../../shared/src/lib/components/layouts/dashboard-layout/dashboard-layout.component';
import ParametersRoutes from '../../../admin/src/app/dashboard/set-ups/parameters/parameters.routes';
import { userMenuGuard } from '../../../shared/src/lib/user-menu.guard';

export const routes: Routes = [
  {
    path: '',
    component: DashboardLayoutComponent,
    canActivate: [userMenuGuard],
    loadChildren: () => import('./crm.routes'),
  },
  {
    path: '',
    component: DashboardLayoutComponent,
    children: [
      {
        path: 'admin',
        canActivate: [userMenuGuard],
        children: [
          ...ParametersRoutes,
          {
            path: 'user',
            children: [
              {
                path: 'users',
                loadChildren: () => import('../../../admin/src/app/dashboard/set-ups/users/users.routes'),
              },
              {
                path: 'groups',
                loadChildren: () =>
                  import('../../../admin/src/app/dashboard/set-ups/user-groups/users-groups.routes'),
              },
            ],
          },
        ],
      },
      {
        path: 'access-denied',
        loadComponent: () =>
          import('../../../shared/src/lib/components/access-denied/access-denied.component').then(
            (c) => c.AccessDeniedComponent,
          ),
      },
    ],
  },
];
